export const PIXEL_ID = "1708011996393600";

export function metaTrack(eventName, data = {}, eventId) {
  try {
    if (typeof window === "undefined" || typeof window.fbq !== "function") return false;
    if (eventId) window.fbq("track", eventName, { ...data }, { eventID: eventId });
    else window.fbq("track", eventName, { ...data });
    return true;
  } catch {
    return false;
  }
}

export const productData = (product) => ({
  content_ids: [String(product.id)],
  content_type: "product",
  content_name: product.name,
  content_category: product.category,
  value: Number(product.price),
  currency: "INR",
});

export const cartEventData = (items, total) => ({
  content_ids: items.map((i) => String(i.id || i.product_id)),
  contents: items.map((i) => ({ id: String(i.id || i.product_id), quantity: Number(i.qty) })),
  content_type: "product",
  num_items: items.reduce((n, i) => n + i.qty, 0),
  value: Number(total),
  currency: "INR",
});
